import {lazyRegister} from '@/Core/lazyRegister';
import './LangSelectBox/langSelectBox.component';
import './menu-node/menu-node.component';
import './user-menu/user-menu.component';
import template from './topMenu.component.html';
import './topMenu.component.css';
import {AdminUserRole, RolesType, WebshopRootScope} from "@/models";
import {DistributorService} from "@/Services";
import {MenuNode} from "./menu-node/menu-node.component";

class TopMenuController implements ng.IController {
    static $inject = [
        '$element',
        '$scope',
        '$rootScope',
        'DistributorService'
    ];

    public isExpanded: boolean = false;
    public logoBrand: string = "/assets/imgs/logo.png";
    private readonly cancelToken = new AbortController();
    userRoles: RolesType[];
    menuTree: MenuNode[];

    constructor(
        private $element: ng.IAugmentedJQuery,
        private $scope: ng.IScope,
        private $rootScope: WebshopRootScope,
        private distributorService: DistributorService
    ) {
    }

    async $onInit() {

        const MENU_ITEMS_BASE: MenuNode[] = [
            {
                menuKey: "be_menu_ctl",
                icon: "fa-solid fa-cubes",
                rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.Ecommerce, AdminUserRole.EcommerceAdmin, AdminUserRole.Dealer],
                children: [
                    {
                        menuKey: "be_menu_ctl_mp",
                        link: "/products",
                        icon: "fa-solid fa-box-open"
                    },
                    {
                        menuKey: "be_menu_ctl_mc",
                        link: "/categories",
                        icon: "fa-solid fa-th-list",
                        rolesExcluded: [AdminUserRole.Dealer]
                    },
                    {
                        menuKey: "be_menu_ctl_pt",
                        link: "/tags",
                        hasSeparator: true,
                        rolesExcluded: [AdminUserRole.Dealer]
                    },
                    {
                        menuKey: "be_menu_ctl_md",
                        link: "/master-data-list",
                        rolesExcluded: [AdminUserRole.Dealer]
                    },
                    {
                        menuKey: "be_menu_promotions_list",
                        link: "/product-promotions",
                        rolesExcluded: [AdminUserRole.Dealer],
                    },
                    {
                        menuKey: 'be_menu_product_statistic',
                        hasSeparator: true,
                        isSubLevel: true,
                        disabled: this.$rootScope.APP_CONFIG.currentEnvironment == 'Production',
                        icon: 'fa-solid fa-ranking-star',
                        children: [
                            {
                                menuKey: 'be_menu_ctl_pp',
                                link: '/statistics/popular-products',
                                icon: "fa-solid fa-fire"
                            }, {
                                menuKey: 'be_menu_ctl_bs',
                                link: '/statistics/best-seller-products',
                                icon: "fa-solid fa-rocket"
                            }
                        ]
                    },
                    {
                        hasSeparator: true,
                        menuKey: "be_menu_ctl_mf",
                        link: "/filter",
                        icon: "fa-solid fa-cog",
                        rolesExcluded: [AdminUserRole.Dealer, AdminUserRole.Ecommerce]
                    },
                ]
            },
            {
                menuKey: "be_menu_cm",
                icon: "fa-solid fa-users",
                rolesAllowed: ["*"],
                children: [
                    {
                        menuKey: "be_menu_cm_mc",
                        link: "/customers",
                        icon: "fa-solid fa-user",
                        rolesAllowed: ["*"]
                    }, {
                        menuKey: "be_menu_cm_purchaser",
                        link: "/purchasers",
                        icon: "fa-solid fa-envelope",
                        rolesAllowed: [
                            AdminUserRole.SuperAdmin,
                            AdminUserRole.CustomerServiceAdmin,
                            AdminUserRole.EcommerceAdmin,
                            AdminUserRole.Dealer
                        ]
                    },
                    {
                        menuKey: "be_menu_cm_cg",
                        link: "/customer-groups",
                        icon: "fa-solid fa-users",
                        rolesAllowed: [
                            AdminUserRole.SuperAdmin,
                            AdminUserRole.CustomerServiceAdmin,
                            AdminUserRole.EcommerceAdmin,
                            AdminUserRole.Dealer]
                    },
                    {
                        menuKey: "be_menu_cm_ns",
                        link: "/newsletter-subscribers",
                        icon: "fa-solid fa-bell",
                        rolesAllowed: [
                            AdminUserRole.SuperAdmin,
                            AdminUserRole.Ecommerce,
                            AdminUserRole.EcommerceAdmin
                        ]
                    }
                ]
            },
            {
                menuKey: "be_menu_dl",
                icon: "fa-solid fa-handshake",
                rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.CustomerService, AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin],
                children: [
                    {
                        menuKey: "be_menu_dl_md",
                        link: "/dealers",
                        icon: "fa-solid fa-users-gear",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.CustomerService, AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin]
                    },
                    {
                        menuKey: "be_menu_dl_gr_md",
                        link: "/dealer-groups",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin]
                    }
                ]
            },
            {
                menuKey: "be_menu_dl_bs",
                icon: "fa-solid fa-handshake",
                rolesAllowed: [AdminUserRole.Dealer],
                rolesExcluded: [AdminUserRole.SuperAdmin],
                children: [
                    {
                        menuKey: "be_menu_dl_bs",
                        link: "/dealer/profile"
                    }, {
                        menuKey: "be_menu_dl_sub_accounts",
                        link: "/dealer/sub-accounts",
                        disabled: this.$rootScope.APP_CONFIG.currentEnvironment == 'Production'
                    }
                ]
            },
            {
                menuKey: "be_menu_pm",
                icon: "fa-solid fa-arrow-up",
                rolesAllowed: [
                    AdminUserRole.SuperAdmin,
                    AdminUserRole.Ecommerce,
                    AdminUserRole.EcommerceAdmin,
                    AdminUserRole.CustomerServiceAdmin,
                    AdminUserRole.Dealer
                ],
                children: [
                    {menuKey: "be_menu_shipping", icon: "fa-solid fa-truck", link: "/shipping-management"},
                    {menuKey: "be_menu_pricelist", icon: "fa-solid fa-tag", link: "/pricelist"},
                    {
                        menuKey: "be_menu_customer_group_discount",
                        icon: "fa-solid fa-user-tag",
                        link: "/customer-group-discount"
                    },
                    {menuKey: "be_menu_campaign", icon: "fa-solid fa-bullhorn", link: "/campaign"},
                    {menuKey: "be_menu_pm_cp", icon: "fa-solid fa-ticket", link: "/coupon"}
                ]
            },
            {
                menuKey: "be_menu_ct",
                icon: "fa-solid fa-images",
                rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin],
                children: [
                    {
                        menuKey: "be_menu_ct_il",
                        link: "/imagestore",
                        icon: "fa-solid fa-images"
                    },
                    {
                        menuKey: "be_menu_ct_hp",
                        link: "/home-frontend",
                        icon: "fa-solid fa-house",
                        rolesExcluded: [AdminUserRole.CustomerServiceAdmin]
                    },
                    {
                        menuKey: "be_menu_ct_seo",
                        link: "/seo-generate",
                        icon: "fa-solid fa-chart-line",
                        rolesExcluded: [AdminUserRole.CustomerServiceAdmin]
                    },
                    {
                        menuKey: "be_menu_ct_op",
                        link: "/other-pages",
                        icon: "fa-solid fa-file-lines",
                        rolesExcluded: [AdminUserRole.CustomerServiceAdmin]
                    }
                ]
            },
            {
                menuKey: "be_menu_st",
                icon: "fa-solid fa-database",
                rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin],
                children: [
                    {
                        menuKey: "be_menu_st_ma",
                        icon: "fa-solid fa-user-secret",
                        link: "/manage-user",
                        rolesAllowed: [AdminUserRole.SuperAdmin]
                    },
                    {
                        menuKey: "be_menu_st_sv",
                        link: "/storeview",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.EcommerceAdmin]
                    },
                    {
                        menuKey: "be_menu_st_url",
                        link: "/synchronize-url",
                        rolesAllowed: [
                            AdminUserRole.SuperAdmin,
                            AdminUserRole.EcommerceAdmin,
                            AdminUserRole.CustomerServiceAdmin
                        ]
                    },
                    {
                        menuKey: "be_menu_st_curl",
                        link: "/url-redirecting",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.EcommerceAdmin]
                    },
                    {
                        hasSeparator: true,
                        menuKey: "be_menu_st_lc",
                        link: "/localization",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.EcommerceAdmin]
                    },
                    {
                        menuKey: "be_menu_st_et",
                        link: "/email-templates",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.EcommerceAdmin]
                    },
                    {
                        menuKey: "Last visitors",
                        link: "/last-visitors",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin]
                    },
                    {
                        menuKey: "be_menu_FAQ",
                        link: "/pageFAQ",
                        rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin]
                    },
                    {
                        menuKey: "be_menu_admin_Submenu",
                        isSubLevel: true,
                        hasSeparator: true,
                        icon: "fa-solid fa-cog",
                        rolesAllowed: [AdminUserRole.SuperAdmin],
                        children: [
                            {
                                menuKey: "be_menu_st_rr",
                                link: "/returnreasons",
                                rolesAllowed: [AdminUserRole.SuperAdmin]
                            },
                            {
                                menuKey: "be_menu_st_rm",
                                link: "/rating-emails",
                                rolesAllowed: [AdminUserRole.SuperAdmin]
                            },
                            {menuKey: "be_menu_st_cc", link: "/clearcache", rolesAllowed: [AdminUserRole.SuperAdmin]},
                            {
                                menuKey: "be_menu_st_setting",
                                link: "/systemSetting",
                                rolesAllowed: [AdminUserRole.SuperAdmin]
                            },
                            {menuKey: "Log history", link: "/logHistory", rolesAllowed: [AdminUserRole.SuperAdmin]},
                            {
                                menuKey: "Job management",
                                link: "/jobs-management",
                                rolesAllowed: [AdminUserRole.SuperAdmin]
                            },
                            {
                                menuKey: "Service Health",
                                link: "/api/HealthChecking",
                                rolesAllowed: [AdminUserRole.SuperAdmin],
                                isExternal: true
                            },
                            {
                                menuKey: "Encrypt Key Generate",
                                link: "/api/GenerateRSAKey",
                                rolesAllowed: [AdminUserRole.SuperAdmin],
                                isExternal: true
                            }
                        ]
                    }
                ]
            },
            {
                menuKey: "be_menu_sm",
                icon: "fa-solid fa-shopping-cart",
                rolesAllowed: [AdminUserRole.SuperAdmin, AdminUserRole.Dealer, AdminUserRole.CustomerService,
                    AdminUserRole.CustomerServiceAdmin, AdminUserRole.EcommerceAdmin],
                children: [
                    {
                        menuKey: "be_menu_sm_o",
                        link: "/orders",
                        icon: "fa-solid fa-file-invoice"
                    }, {
                        menuKey: "be_menu_orders_statistic",
                        link: "/orders/statistic",
                        icon: "fa-solid fa-chart-column"
                    },
                    {
                        menuKey: "be_menu_sm_ro",
                        link: "/return-orders",
                        icon: 'fa-solid fa-reply'
                    },
                    {
                        menuKey: "be_menu_sm_ox",
                        link: "/export-orders",
                        icon: "fa-solid fa-file-export"
                    },
                    {
                        menuKey: "be_menu_sm_os",
                        link: "/order-status",
                        icon: "fa-solid fa-list-check"
                    }
                ]
            }
        ]

        this.$element.addClass('top-menu');

        if (this.$rootScope.LoggedInUser?.Role === AdminUserRole.Dealer) {
            const dealerNumbers = this.$rootScope.LoggedInUser.DealerNumbers;
            const {Value} = await this.distributorService
                .getLogoByNumber(dealerNumbers, this.cancelToken.signal);
            if (!!Value) {
                this.logoBrand = this.$rootScope.APP_CONFIG.imageStorageUrl + encodeURI(Value);
                this.$scope.$applyAsync();
            }
        }

        this.userRoles = [this.$rootScope.LoggedInUser?.Role];
        this.menuTree = this.filterMenuByRoles(MENU_ITEMS_BASE, this.userRoles);
        this.$scope.$applyAsync();
    }

    $onDestroy() {
        this.cancelToken.abort();
    }

    private filterMenuByRoles(menuItems: MenuNode[], userRoles: RolesType[], parentRoles?: string[]): MenuNode[] {
        return menuItems
            .map(item => {
                // Tạo một bản sao (clone) để tránh ghi đè trực tiếp vào mảng data gốc
                const clonedItem = structuredClone(item);

                // CƠ CHẾ KẾ THỪA: Nếu bản thân con KHÔNG khai báo rolesAllowed,
                // nó sẽ tự động copy lại mảng quyền của cha nó truyền xuống
                if (!clonedItem.rolesAllowed) {
                    clonedItem.rolesAllowed = parentRoles;
                }
                return clonedItem;
            })
            // BƯỚC LỌC 1: Giữ lại những menu mà user có quyền truy cập
            .filter(item =>
                !item.disabled &&
                this.$rootScope.checkUserInRolesAllByRoles(userRoles, item.rolesAllowed, item.rolesExcluded)
            )

            // BƯỚC LỌC 2: Tiếp tục đi sâu vào các nhánh con (children) nếu có
            .map(item => {
                if (item.children && item.children.length > 0) {
                    // Đệ quy: Đẩy rolesAllowed hiện tại làm parentRoles cho các con của nó
                    item.children = this.filterMenuByRoles(item.children, userRoles, item.rolesAllowed!);
                }
                return item;
            })
            // BƯỚC LỌC 3: Dọn dẹp giao diện
            // Nếu một menu cha có children, nhưng sau khi lọc các con bên trong đều bị ẩn sạch,
            // thì bản thân cái menu cha đó cũng phải bị ẩn đi (trừ trường hợp nó là một link bấm trực tiếp)
            .filter(item => !item.menuKey || (item.children && item.children.length > 0) || item.link !== '#');
    }
}

lazyRegister.component('topMenu', {
    template: template,
    controller: TopMenuController
});
